export const NAME = 'cofidis';

export const SET_REQUEST_ID = 'SET_REQUEST_ID';
export const SET_MERCHANT_TRANSACTION_ID = 'SET_MERCHANT_TRANSACTION_ID';

export const REQUEST_COFIDIS_ELIGIBILITY = 'REQUEST_COFIDIS_ELIGIBILITY';
export const SUCCESS_COFIDIS_ELIGIBILITY = 'SUCCESS_COFIDIS_ELIGIBILITY';
export const FAILURE_COFIDIS_ELIGIBILITY = 'FAILURE_COFIDIS_ELIGIBILITY';

export const REQUEST_COFIDIS_INITIALIZE = 'REQUEST_COFIDIS_INITIALIZE';
export const SUCCESS_COFIDIS_INITIALIZE = 'SUCCESS_COFIDIS_INITIALIZE';
export const FAILURE_COFIDIS_INITIALIZE = 'FAILURE_COFIDIS_INITIALIZE';

export const REQUEST_COFIDIS_CONFIRM = 'REQUEST_COFIDIS_CONFIRM';
export const SUCCESS_COFIDIS_CONFIRM = 'SUCCESS_COFIDIS_CONFIRM';
export const FAILURE_COFIDIS_CONFIRM = 'FAILURE_COFIDIS_CONFIRM';

export const INSTALLMENTS_3X = '3X';
export const INSTALLMENTS_4X = '4X';



// WEBPACK FOOTER //
// ./src/services/cofidis/constants.js